module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"umd":"L","root":"L","global":"L","commonjs2":"leaflet","commonjs":"leaflet","amd":"leaflet"}
// module id = 0
// module chunks = 0